import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import {
  convertSecondsFromStringTime,
  formatTimeFromSeconds,
} from "@/services/functions";

import DeliveryPlanType from "@/types/DeliveryPlan"
import AlertSettingType from "@/types/AlertSetting"


export default /*@__PURE__*/_defineComponent({
  __name: 'WeeklyAggregationRow',
  props: {
    detailDataRef: {},
    index: {},
    detailData: {},
    alertSetting: {}
  },
  setup(__props: any) {

const props = __props;

// 明細、小計の時間はアラートLv3をチェックしない
const restraintTimeStyle = computed(() => {
  const totalByTrip = summary("total_by_trip");
  if (!totalByTrip) return "color: black;";

  const restraintTimeSeconds = totalByTrip;

  const alertLv2TimeSeconds = convertSecondsFromStringTime(
    props.alertSetting?.alertLv2Time
  );
  if (
    props.alertSetting?.alertLv2Time &&
    restraintTimeSeconds > alertLv2TimeSeconds
  ) {
    return "color: " + props.alertSetting?.alertLv2Color;
  }

  const alertLv1TimeSeconds = convertSecondsFromStringTime(
    props.alertSetting?.alertLv1Time
  );
  if (
    props.alertSetting?.alertLv1Time &&
    restraintTimeSeconds > alertLv1TimeSeconds
  ) {
    return "color: " + props.alertSetting?.alertLv1Color;
  }

  return "color: black;";
});

const summaryTargetTrips = computed(() => {
  const trips = [];
  if (!props.detailData.weeklyAggregation) return trips;

  const cp = JSON.parse(JSON.stringify(props.detailDataRef));
  for (
    let i = props.index;
    i >= 0 && (i == props.index || !props.detailDataRef[i]?.weeklyAggregation);
    i--
  ) {
    if (!props.detailDataRef[i]) continue;
    (props.detailDataRef[i].trips ?? []).forEach((trip) => {
      trips.push(trip);
    });
  }
  return trips;
});

const summary = (key) => {
  let sum = 0;
  summaryTargetTrips.value.forEach((trip) => {
    sum += trip[key];
  });
  return sum;
};

// show formatted time

const formattedNextTimeByTrip = computed(() => {
  const sum = summary("next_time_by_trip");
  return formatTimeFromSeconds(sum);
});

const formattedTotalDriving = computed(() => {
  const sum = summary("total_driving");
  return formatTimeFromSeconds(sum);
});

const formattedTotalMileage = computed(() => {
  return summary("total_mileage");
});

const formattedDriving = computed(() => {
  const sum = summary("driving");
  return formatTimeFromSeconds(sum);
});

const formattedBreak = computed(() => {
  const sum = summary("break");
  return formatTimeFromSeconds(sum);
});

const formattedLoadingTime = computed(() => {
  const sum = summary("loading_time");
  return formatTimeFromSeconds(sum);
});

const formattedUnloadingTime = computed(() => {
  const sum = summary("unloading_time");
  return formatTimeFromSeconds(sum);
});

const formattedShippingTime = computed(() => {
  const sum = summary("shipping_time");
  return formatTimeFromSeconds(sum);
});

const formattedWaitTime = computed(() => {
  const sum = summary("wait_time");
  return formatTimeFromSeconds(sum);
});

const formattedOthersTime = computed(() => {
  const sum = summary("others_time");
  return formatTimeFromSeconds(sum);
});

const formattedTotalByTrip = computed(() => {
  const sum = summary("total_by_trip");
  return formatTimeFromSeconds(sum);
});

const formattedWorkingTime = computed(() => {
  const sum = summary("working_time");
  return formatTimeFromSeconds(sum);
});

const formattedLeavingDiffTime = computed(() => {
  const sum = summary("leaving_diff_time");
  return formatTimeFromSeconds(sum);
});

const formattedOverTime = computed(() => {
  const sum = summary("over_time");
  return formatTimeFromSeconds(sum);
});

const formattedOverNightTime = computed(() => {
  const sum = summary("over_night_time");
  return formatTimeFromSeconds(sum);
});

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("tr", null, [
    _cache[0] || (_cache[0] = _createElementVNode("td", { colspan: "4" }, "小計", -1)),
    _createElementVNode("td", null, _toDisplayString(formattedTotalDriving.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedNextTimeByTrip.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedTotalMileage.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedDriving.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedBreak.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedLoadingTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedUnloadingTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedShippingTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedWaitTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedOthersTime.value), 1),
    _createElementVNode("td", {
      style: _normalizeStyle(restraintTimeStyle.value)
    }, _toDisplayString(formattedTotalByTrip.value), 5),
    _createElementVNode("td", null, _toDisplayString(formattedWorkingTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedLeavingDiffTime.value), 1),
    _cache[1] || (_cache[1] = _createElementVNode("td", null, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1)),
    _createElementVNode("td", null, _toDisplayString(formattedOverTime.value), 1),
    _createElementVNode("td", null, _toDisplayString(formattedOverNightTime.value), 1)
  ], 512)), [
    [_vShow, !!__props.detailData.weeklyAggregation]
  ])
}
}

})